<template>
  <div class="body-common" v-if="dataDetail">
    <div class="albumtop flexdiv" :style="{ 'background-image': 'url(' + dataDetail.albumCoverUrl + ')' }">
      <div class="media color-white">
        <div class="media-object media-left">
          <img class="border-radius2 maxsize" style="height: 110px" :src="dataDetail.albumCoverUrl" />
        </div>
        <div class="media-body">
          <h1 class="media-heading">{{ dataDetail.albumGoodsName }}</h1>
          <p class="media-tag mt12">
            <span v-for="(item, index) in dataDetail.albumTags" :key="index">{{ item }}</span>
            <span>{{ dataDetail.albumDifficulty }}</span>
          </p>
          <p class="opacity8 line2" @click="goIntro()">
            {{ dataDetail.albumDescription }}
          </p>
        </div>
      </div>
    </div>
    <div
      class="unlock flexdiv spacebetween topradius-con"
      v-if="dataDetail.albumActivityInfo && dataDetail.buyButtonStatus !== '20'"
    >
      <template v-if="dataDetail.albumActivityInfo.activityProcess === 0">
        <div>
          {{ dataDetail.albumActivityInfo.activityGoodsPrice }}
          元解锁前
          {{ dataDetail.albumActivityInfo.unlockCourseNum }}
          节 邀请
          {{ dataDetail.albumActivityInfo.inviteUserNum }}
          人解锁全部
        </div>
        <div @click="createOrder">立即解锁 ></div>
      </template>
      <template v-else-if="dataDetail.albumActivityInfo.activityProcess === 1">
        <div>
          已邀请
          <span class="bgfont">{{ dataDetail.albumActivityInfo.inviteSuccessUserNum }}</span>
          人， 再邀请
          <span class="bgfont">
            {{ dataDetail.albumActivityInfo.inviteUserNum - dataDetail.albumActivityInfo.inviteSuccessUserNum }}
          </span>
          人解锁全部
        </div>
        <div @click="shareImgShow">查看详情 ></div>
      </template>
    </div>
    <div class="courseList topradius-con">
      <h1 class="title-line pd16">共{{ totalList }}课</h1>
      <div class="pd16 mediablock">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text=""
            offset="10"
            @load="onLoad"
          >
            <div v-for="item in courseList" :key="item.courseId" class="media" @click="onItemClick(item)">
              <div style="width: 60px; height: 60px" class="media-object media-left courseimg">
                <span class="icon-lock" v-if="item.courseStatus === 'lock'"></span>
                <span class="icon-shiting" v-if="item.courseStatus === 'try'">试听课</span>
                <img class="border-radius2 maxsize" :src="item.courseCoverUrl" />
              </div>
              <div class="media-body">
                <h1 class="media-heading" style="font-weight: 500">{{ item.courseGoodsName }}</h1>

                <p class="color-gray3">
                  {{ item.teacherName }} {{ item.courseDifficulty }} {{ parseDate(item.courseMs) }}
                </p>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <div class="fixed-bottom flexdiv average">
      <template v-if="dataDetail.buyButtonStatus === '1'">
        <div
          @click="goBuy"
          class="block btn-common btn-primary txt-center color-green"
          style="padding: 15px 0 10px; font-weight: bold; flex: 0.7"
        >
          ￥{{ dataDetail.salePrice }}购买
        </div>
      </template>
      <template v-if="dataDetail.albumActivityInfo">
        <template v-if="dataDetail.albumActivityInfo.activityProcess === 1">
          <div class="mybreath block btn-common btn-orange ml16" @click="shareImgShow">
            再邀请{{
              dataDetail.albumActivityInfo.inviteUserNum - dataDetail.albumActivityInfo.inviteSuccessUserNum
            }}人解锁
          </div>
        </template>
        <template v-if="dataDetail.albumActivityInfo.activityProcess === 0 && dataDetail.buyButtonStatus !== '20'">
          <div @click="createOrder" class="mybreath block btn-common btn-orange ml16">
            {{ dataDetail.albumActivityInfo.activityGoodsPrice }}元解锁
          </div>
        </template>
      </template>
      <!-- <template v-if="dataDetail.buyButtonStatus === '20'">
        <div class="btn-common txt-center color-green" @click="downloadgo">
          已全部解锁，前往App观看体验更加哦~
        </div>
      </template> -->
    </div>
    <div class="dialog-mask" v-if="[0, 2, 3].includes(dataDetail.albumActivityInfo.activityStatus)">
      <div class="dialog-album dialog-disbled">
        <div class="dialog-warning"></div>
        <div class="dialog-content" v-if="dataDetail.albumActivityInfo.activityStatus === 0">
          <h1>活动还未开始哦</h1>
          <p class="color-gray3 mtb16 font14">敬请期待～</p>
        </div>
        <div class="dialog-content" v-else>
          <h1>活动已结束</h1>
          <p class="color-gray3 mtb16 font14">下次再来吧～</p>
        </div>
      </div>
    </div>
    <div class="dialog-mask" v-if="dataDetail.buyButtonStatus === '20'">
      <div class="dialog-album">
        <div class="dialog-warning"></div>
        <div class="dialog-content">
          <h1>您已具备该商品权益</h1>
          <p class="color-gray3 mtb16 font14">为了更好的学习体验，请前往APP进行学习</p>
          <div class="btn-common" @click="downloadgo">前往学习</div>
        </div>
      </div>
    </div>
    <div
      class="dialog-mask"
      v-if="dataDetail.albumActivityInfo.activityProcess === 2 && dataDetail.buyButtonStatus === '1'"
    >
      <div class="dialog-album">
        <div class="dialog-warning"></div>
        <div class="dialog-content">
          <h1>您已参加过该活动</h1>
          <p class="color-gray3 mtb16 font14">请勿重复参加哦～</p>
        </div>
      </div>
    </div>

    <div class="dialog-mask" v-if="dialogShow">
      <div class="my-swiper" v-if="qrImgpath">
        <div class="poster-show" v-show="posterObj.picUrl && qrImgpath" id="poster">
          <img
            style="position: absolute; z-index: 100; top: 0; left: 0; opacity: 0"
            class="cover"
            crossorigin="anonymous"
            :src="posterObj.canvasUrl"
            alt=""
          />

          <img :src="posterObj.picUrl" @load="onImageLoad()" crossorigin="anonymous" />
          <div class="qrcode" v-if="qrImgpath">
            <img :src="qrImgpath" />
          </div>
        </div>

        <div class="swiper-pagination" slot="pagination"></div>

        <div class="longpress" style="bottom: -55px">
          <p>长按并保存图片，分享至朋友圈</p>
          <p class="mt5">
            邀请
            <span class="bgfont" style="background-color: #ff7142">
              {{ dataDetail.albumActivityInfo.inviteUserNum - dataDetail.albumActivityInfo.inviteSuccessUserNum }}
            </span>
            位好友扫码报名，将获得全部内容
          </p>
        </div>
      </div>
      <div class="dialog-close top-right" @click="dialogShow = false">×</div>
    </div>

    <div class="dialog-mask" v-if="dialogSm" @click="dialogSm = false">
      <div class="dialog-body">
        <div class="pd30 border-radius8 bg-white txt-center boxshadow">
          <div class="media media-updown">
            <div class="media-body">
              <div class="media-heading font18">长按扫描添加老师微信</div>
              <p class="mtb16">
                <font class="color-orange">完成报名</font>
                <font>才能观看课程</font>
              </p>
            </div>
            <div class="media-object fullwidth">
              <img style="width: 70%" :src="adviserInfo.adviserCode" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { appUser, throttle, storage } from '@/utils'
import { mapGetters } from 'vuex'
import Body from '@/mixins/body'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import QRCode from 'qrcode'
import { getPageUrl } from '@/utils/common/url'
import { Indicator } from 'mint-ui'
import { Toast, Dialog } from 'vant'
import { $openWebPage, $gotoPosterPage, $settingBounces, $dataHandle } from '@/utils/common/native-api'
import { saTrack } from '@/utils/common/shence'
import service from '@/api/modules/payment/album'
import { Pay } from '@/utils/common/pay'
import { toLoginView } from '@/utils/init/env-init'
import { getCookie } from '@/utils/common/cookie'

import html2canvas from 'html2canvas'
// 操作名称
const action = 'album'
export default {
  name: 'AlbumList',
  components: {},
  data() {
    return {
      title: '友邻少年',
      appUser,
      loaded: true, // 是否空数据
      refreshing: false,
      page: 0,
      dataDetail: null,
      courseList: [],
      isLoading: false,
      finished: false,
      loading: false,
      totalList: 0,
      dialogShow: false,
      qrImgpath: '',
      posterObj: {},
      paymethods: [{ label: '微信支付', value: 1, icon: 'icon_wechatpay' }],
      paymethod: 1,
      saData: {},
      dialogSm: false,
      adviserInfo: {}
    }
  },
  mixins: [Body],
  created() {
    // this.$router.replace({ path: '/album-list' })
    this.getDetail()
  },
  mounted() {},
  computed: {
    ...mapGetters('args', ['shareCode']),
    ...mapGetters('payment/order', [
      'create' // 下单后的订单
    ])
  },
  methods: {
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      this.getDetail()
    },
    getDetail() {
      service
        .getAlbumInfo({
          shareCode: this.shareCode
        })
        .then(res => {
          this.dataDetail = res
          this.posterObj = this.dataDetail.albumActivityInfo.shareImgUrlList[0]
          try {
            saTrack('h5_courseunlock_view', {
              courseunlock_title: res.albumActivityInfo.activityName, //解锁活动名称
              activity_id: res.albumActivityInfo.activityId, //活动ID
              album_goods_id: res.albumGoodsId, //专辑ID
              album_goods_title: res.albumGoodsName, //专辑名称
              courseunlock_state: res.albumActivityInfo.activityStatus, //活动状态
              courseunlock_advance_charge: res.albumActivityInfo.activityGoodsPrice, //预付金额
              courseunlock_invite_friends: res.albumActivityInfo.inviteUserNum, //应邀好友人数
              courseunlock_invite_friends_success: res.albumActivityInfo.inviteSuccessUserNum, //成功邀请好友人数
              inviter_id: appUser.userId, //邀请者ID
              poster_id: this.posterObj.picId //海报ID
            })
          } catch (err) {}
          //获取课程列表
          this.onLoad()
          //生成海报二维码
          this.makeQRcode()
        })
    },
    onRefresh() {
      this.page = 0
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      // this.courseList = []
      this.onLoad()
    },
    onLoad() {
      this.page += 1
      let data = {
        albumId: this.dataDetail.albumId,
        albumGoodsId: this.dataDetail.albumGoodsId,
        sortType: 'asc',
        choice: false
      }
      service
        .getAlbumCourse({
          currentPage: this.page,
          pageSize: 10,
          ...data
        })
        .then(res => {
          Indicator.close()
          if (this.refreshing) {
            this.refreshing = false
          }
          const { list, total } = res
          this.totalList = total
          this.loading = false
          this.isLoading = false
          if (this.courseList.length === total) this.finished = true
          if (this.page === 1) {
            this.courseList = list
          } else {
            this.courseList = this.courseList.concat(list)
          }
          console.log(this.courseList)
          const courseList = document.querySelectorAll('.list_box .list_item .van-image')
          if (courseList.length) {
            const wpx = courseList[0].offsetWidth
            courseList.forEach(item => {
              item.style.height = wpx + 'px'
            })
          }
        })
        .catch(() => {
          Indicator.close()
        })
    },
    // 设置分享数据
    setShareData() {
      const { shareMainTitle, shareSecondTitle, shareImg } = this.dataDetail.albumActivityInfo
      if (shareMainTitle) {
        return {
          title: `${shareMainTitle}`,
          desc: `${shareSecondTitle}`,
          link: location.href,
          imgUrl: shareImg
        }
      }
    },
    parseDate(str) {
      if (str) {
        return new Date(str).toFormattedString('mm:ss')
      }
    },
    // 详情
    onItemClick(item) {
      //courseStatus:"try","give","lock", "unlock"
      if (item.courseStatus !== 'lock') {
        this.getAdviserInfo(item)
      }
    },
    //专辑详情介绍
    goIntro() {
      saTrack('h5_courseunlock_illustrate_click', {
        activity_id: this.dataDetail.albumActivityInfo.activityId, //活动ID
        album_goods_id: this.dataDetail.albumGoodsId //专辑ID
      })
      this.$router.push({
        path: '/album-detail'
      })
    },
    //生成二维码
    makeQRcode() {
      let shareQrContent = this.posterObj.shareUrl
      if (!shareQrContent) return
      const opts = {
        errorCorrectionLevel: 'H',
        type: 'image/jpeg',
        quality: 0.3,
        margin: 1
      }
      QRCode.toDataURL(shareQrContent, opts).then(url => {
        this.qrImgpath = url
      })
    },
    onImageLoad() {
      this.createImage()
    },
    createImage() {
      try {
        const capture = document.getElementById('poster')
        html2canvas(capture, {
          backgroundColor: null,
          useCORS: true,
          width: capture.offsetWidth - 2,
          height: capture.offsetHeight - 2,
          scrollX: 0,
          scrollY: 0,
          x: 0,
          y: 0,
          scale: 3
        })
          .then(canvas => {
            // document.body.appendChild(canvas)
            const dataURL = canvas.toDataURL('image/png')
            this.$set(this.posterObj, 'canvasUrl', dataURL)
            this.$forceUpdate()
          })
          .finally(() => {
            console.log('生成结束')
            Toast.clear()
          })
      } catch (err) {
        Toast.clear()
      }
    },
    //海报弹窗
    shareImgShow() {
      saTrack('h5_courseunlock_posterswindow', {
        operator: appUser.userId, //邀请者ID
        poster_id: this.posterObj.picId, //海报ID
        activity_id: this.dataDetail.albumActivityInfo.activityId, //活动ID
        album_goods_id: this.dataDetail.albumGoodsId //专辑ID
      })
      this.dialogShow = true
    },

    goBuy() {
      if (!this.hasUser()) return

      this.$router.push({
        path: `/confirm-order/${this.dataDetail.albumGoodsId}`,
        query: { paytype: 'goods', transferType: 'album' }
      })
    },
    createOrder() {
      if (!this.hasUser()) return
      let amount = this.dataDetail.albumActivityInfo.activityGoodsPrice

      // 调用原生购买方法
      let source = 'APP'
      if (appUser.isWeixin) source = 'PUB'
      if (appUser.isBrowser) source = 'WEB'

      const userReferrer = getCookie('userReferrer')

      let data = {
        source,
        payType: 'WX',
        addressId: '',
        amount: amount,
        discount: 0.0,
        goodsId: this.dataDetail.albumGoodsId,
        installmentId: 0,
        sellerCode: this.shareCode, // 分享者编码
        totalPrice: amount,
        userId: appUser.userId,
        openId: appUser.openId,
        userNote: '',
        userReferrer,
        creditCount: 0,
        isUnlockPrice: true
      }

      this.$store
        .dispatch('payment/order/create', data)
        .then(res => {
          let order = { ...data, ...res }
          console.log(res)

          this.payOrder(order)
        })
        .catch(err => {
          console.log(err)
          Toast({ message: err.message })
        })
    },
    payOrder(order) {
      console.log('order', order)
      // 微信支付或友邻分期（并设置原生支付回调）
      // this.$store.commit('payment/order/setPopShow', true)
      // localStorage.setItem('showConfirm', true)
      this.$store.commit('payment/order/setOrder', order)

      if (!order.amount) return this.routeSuccess(order)

      const result = Pay(order)

      const toViewHash = '/album-list'
      localStorage.setItem('toViewHash', toViewHash)
      order.goodsId = this.dataDetail.albumGoodsId
      this.$store.commit('payment/order/setCurrentOrder', order)
      if (result != null) {
        result.then(({ status }) => {
          // 查询订单需要商品ID
          order.goodsId = this.dataDetail.albumGoodsId
          this.payOrderResult(order, { status })
        })
      }
    },

    // 查询支付结果（用户退出没有回调，则需要特殊处理）
    payOrderResult(order, { status }) {
      console.log(status, order, '----------0000')

      if (status === 'success') {
        // 标记订单状态
        // 服务器订单状态
        // this.$store.dispatch('payment/order/getPayStatusTime', order).then(data => {
        service.getUnlockOrderStatus({ ...order, shareCode: this.shareCode }).then(data => {
          console.log('支付成功----------', data)
          const { status: payStatus } = data
          // payStatus = 1 // 测试为成功
          console.log(payStatus, '-----1111')
          if (this.successStatus(payStatus)) {
            console.log('支付结果', payStatus, 'data', data)

            this.routeSuccess(order)
            try {
              saTrack('h5_courseunlock_buy', {
                pay_money: order.amount, //邀请者ID
                is_auto_free: order.amount, //海报ID
                is_buy_result: '成功',
                activity_id: this.dataDetail.albumActivityInfo.activityId, //活动ID
                album_goods_id: this.dataDetail.albumGoodsId //专辑ID
              })
            } catch (err) {
              console.log(err)
            }
          } else {
            console.log('支付失败')
            Toast({ message: '订单正在处理，请稍后查询', position: 'bottom' })
          }
        })
      } else if (status === 'cancel') {
        Toast({ message: '用户取消支付~', position: 'bottom' })
      } else {
        // 服务器订单状态
        Toast({ message: '订单支付失败~', position: 'bottom' })
      }
    },
    // 获取下单购买信息
    successStatus(status) {
      return status >= 1
    },
    failStatus(status) {
      return status === -1
    },
    // 跳转成功页面
    routeSuccess(order) {
      saTrack('h5_courseunlock_wecomwindow', {
        activity_id: this.dataDetail.albumActivityInfo.activityId, //活动ID
        album_goods_id: this.dataDetail.albumGoodsId //专辑ID
      })
      this.getDetail()
      this.$router.push({
        path: '/album-paysuccess',
        query: {
          prePayId: order.paymentPrepayId
        }
      })
    },
    downloadgo() {
      if (!this.dataDetail.albumId) return
      window.location.href = `share.html?shareCode=${this.shareCode}#/share-course?albumId=${this.dataDetail.albumId}&albumGoodsId=${this.dataDetail.albumGoodsId}`
    },
    getAdviserInfo(item) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true
      })
      service
        .getAdviserInfo({ albumGoodsId: this.dataDetail.albumGoodsId, courseGoodsId: item.courseGoodsId })
        .then(res => {
          this.adviserInfo = res
          //是否需要添加班主任
          if (res.addAdviser === false) {
            window.location.href = `share.html#/course-detail?albumId=${this.dataDetail.albumId}&albumGoodsId=${this.dataDetail.albumGoodsId}&courseGoodsId=${item.courseGoodsId}`
          } else {
            this.dialogSm = true
            saTrack('h5_courseunlock_wecomwindow', {
              activity_id: this.dataDetail.albumActivityInfo.activityId, //活动ID
              album_goods_id: this.dataDetail.albumGoodsId //专辑ID
            })
          }
        })
        .finally(res => {
          Toast.clear()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.albumtop {
  background-size: 100%;
  background-position: center;
  position: relative;
  padding: 16px 16px 32px;

  .media {
    position: relative;
    z-index: 11;
    .line2 {
      position: relative;
      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        content: '>';
      }
    }
  }
}
.albumtop::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  backdrop-filter: blur(40px); /* 模糊半径 */
  z-index: 10;
}

.unlock {
  position: relative;
  margin-top: -16px;
  background: url('./images/jindubg.png');
  background-size: 100% auto;
  padding: 20px 20px;
  height: 70px;
  font-size: 14px;
  z-index: 12;
  color: #e13800;
}
.bgfont {
  background-color: #e13800;
  color: #fff;
  text-align: center;
  display: inline-block;
  padding: 0 5px;
  min-width: 18px;
  border-radius: 4px;
  line-height: 18px;
  font-weight: bold;
}
.courseList {
  position: relative;
  z-index: 13;
  margin-top: -16px;
  background-color: #fafafa;
  padding-bottom: 70px;
  min-height: 60vh;
}
.courseimg {
  position: relative;
  .icon-lock {
    background: rgba($color: #000000, $alpha: 0.2);
    background-image: url('./images/icon_lock.png');
    background-size: auto 20px;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .icon-shiting {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 22px;
    color: #fff;
    padding-top: 2px;
    border-top-left-radius: 50%;
    border-top-right-radius: 50%;
    text-align: center;
    background: linear-gradient(#017b7b, #00b25a);
  }
}

.dialog-album {
  border-radius: 16px;
  border: 5px solid #009999;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 30px;
  right: 30px;
  transform: translate(0, -50%);
  text-align: center;
  .dialog-warning {
    position: absolute;
    content: '';
    top: -50px;
    left: 0;
    right: 0;
    margin: 0 auto;
    height: 120px;
    width: 120px;
    background-image: url('./images/dialog_warning.png');
    background-repeat: no-repeat;
    background-size: auto 100%;
  }
  &.dialog-disbled {
    border-color: #d6d6d6;
    .dialog-warning {
      background-image: url('./images/dialog_warning_disabled.png');
    }
  }
  .dialog-content {
    margin-top: 60px;
    padding: 16px 32px 32px;
    h1 {
      font-size: 18px;
    }
  }
}

.longpress {
  position: absolute;
  text-align: center;
  left: 0;
  right: 0;
  bottom: -30px;
  font-size: 16px;
  color: #fff;
}
.my-swiper {
  position: absolute;
  width: 100vw;
  height: 135vw;
  top: 50%;
  margin-top: -75vw;
}
.swiper-container {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  .swiper-wrapper .swiper-slide {
    width: 81vw;
    border-radius: 8px;
    overflow: hidden;
    transform: none !important;
    height: 125vw;
    margin-top: 5vw;
    pointer-events: none;
  }
  .swiper-slide-active {
    height: 100% !important;
    margin-top: 0 !important;
  }
  .swiper-wrapper .swiper-slide img {
    width: 100%;
    height: 100%;
  }
  .swiper-pagination {
    font-size: 28px;
    color: #8a91a4;
    bottom: -80px !important;
  }
}
.qrcode {
  position: absolute;
  bottom: 16px;
  right: 16px;
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #000;
  width: 80px;
  height: 80px;
  background-color: #fff;
}
.poster-show {
  position: relative;
  height: 100%;
  width: 81vw;
  text-align: center;
  margin: 0 auto;
  img {
    height: 100%;
    width: 100%;
  }
}
.mybreath {
  animation: myBreath 2s linear infinite;
}
@keyframes myBreath {
  0% {
    transform: scale(0.95);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(0.95);
  }
}
</style>
